import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "seq-ovi-advisory" }
const _hoisted_2 = { class: "seq-echeque-display" }
const _hoisted_3 = { class: "carousel-inner" }
const _hoisted_4 = { class: "p-0 m-0 carousel-indicators carousel-indicators-dots seq-ovi-advisory__indicators" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock("div", {
        key: _ctx.isMobile ? 'mobile' : 'desktop',
        id: "ovi_advisory_carousel",
        class: "carousel carousel-custom slide w-100",
        "data-bs-ride": "carousel",
        "data-bs-interval": "5000"
      }, [
        _createVNode("div", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.slides, (slide, index) => {
            return (_openBlock(), _createBlock("div", {
              key: slide.src,
              class: ["carousel-item", { active: index === 0 }]
            }, [
              _createVNode("img", {
                src: slide.src,
                alt: slide.alt,
                class: "seq-ovi-advisory__img"
              }, null, 8, ["src", "alt"])
            ], 2))
          }), 128))
        ]),
        _createVNode("ol", _hoisted_4, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.slides, (slide, index) => {
            return (_openBlock(), _createBlock("li", {
              key: 'dot-' + slide.src,
              "data-bs-target": "#ovi_advisory_carousel",
              "data-bs-slide-to": index,
              class: { active: index === 0, 'ms-1': index > 0 }
            }, null, 10, ["data-bs-slide-to"]))
          }), 128))
        ])
      ]))
    ])
  ]))
}